var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "gallery__section" },
    [
      _c(
        "headroom",
        {
          staticClass: "fixed--up",
          attrs: { id: "gallery__header--container" }
        },
        [
          _c("div", { staticClass: "gallery__section--header" }, [
            _c("div", { staticClass: "toggle" }, [
              _c(
                "div",
                {
                  staticClass: "bars",
                  class: { active: !_vm.gridView },
                  on: {
                    click: function($event) {
                      _vm.gridView = false
                    }
                  }
                },
                [
                  _c("div", { staticClass: "bar" }),
                  _c("div", { staticClass: "bar" })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "grid",
                  class: { active: _vm.gridView },
                  on: {
                    click: function($event) {
                      _vm.gridView = true
                    }
                  }
                },
                [
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" })
                ]
              )
            ]),
            _c("div", { staticClass: "sectionTitle sectionTitle--mobile" }, [
              _c(
                "div",
                {
                  staticClass: "mobileCategory",
                  on: {
                    click: function($event) {
                      _vm.toggleMobileGallery()
                    }
                  }
                },
                [
                  _c("h1", [_vm._v(_vm._s(_vm.gallery))]),
                  _c("i", { staticClass: "fa fa-chevron-down" })
                ]
              ),
              _vm.mobileGalleryShow
                ? _c(
                    "ul",
                    { staticClass: "gallery__menu" },
                    [
                      _c("h1", [_vm._v("Galleries")]),
                      _c("a", {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            _vm.toggleMobileGallery()
                          }
                        }
                      }),
                      _vm._l(_vm.galleryList.categories, function(category) {
                        return _c(
                          "li",
                          {
                            class: {
                              active: _vm.galleryList.active === category.slug
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "hide-desktop",
                                attrs: { to: /cinemagraphs/ + category.slug },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.toggleMobileGallery()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(category.name))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "sectionTitle sectionTitle--desktop" }, [
              _c("h1", [_vm._v(_vm._s(_vm.gallery))])
            ]),
            _c(
              "div",
              {
                staticClass: "filter",
                on: {
                  mouseover: _vm.filterHoverOn,
                  mouseleave: _vm.filterHoverOff
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "btn btn--black", attrs: { id: "filterBtn" } },
                  [
                    _vm._v("Categories"),
                    _c("i", {
                      staticClass: "fa fa-chevron-down",
                      attrs: { id: "chevron" }
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "filter__container",
                        attrs: { id: "gallery" }
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.galleryList.categories, function(
                            category
                          ) {
                            return _c(
                              "li",
                              {
                                class: {
                                  active:
                                    _vm.galleryList.active === category.slug
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "hide-mobile",
                                    attrs: {
                                      to: /cinemagraphs/ + category.slug
                                    }
                                  },
                                  [_vm._v(_vm._s(category.name))]
                                )
                              ],
                              1
                            )
                          })
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _c("flixel-list", {
        staticClass: "fadeIn",
        attrs: { flixels: _vm.flixels, "grid-view": _vm.gridView }
      }),
      _vm.slideshow.show
        ? _c("slide-show", {
            staticClass: "black showcase-modal",
            attrs: { collection: _vm.flixels, index: _vm.slideshow.index }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de3d508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de3d508","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery.vue
// module id = null
// module chunks = 